/**
 * Window-over-window trend for a failure mode (design doc 015 §6 — the ▲/▼
 * delta the legend shows vs. the immediately-preceding equal-length window).
 *
 * Pure; unit-tested directly.
 */

export type TrendDirection = "up" | "down" | "flat";

export interface ModeTrend {
  /** size_in_window − prev_window_size (can be negative). */
  delta: number;
  direction: TrendDirection;
  /**
   * Percent change vs. the previous window, rounded. `null` when the previous
   * window was empty (no meaningful denominator — typically a brand-new mode).
   */
  pct: number | null;
}

export function modeTrend(size: number, prev: number): ModeTrend {
  const delta = size - prev;
  const direction: TrendDirection =
    delta > 0 ? "up" : delta < 0 ? "down" : "flat";
  const pct = prev > 0 ? Math.round((delta / prev) * 100) : null;
  return { delta, direction, pct };
}
